import React from "react";
import FieldType from "./FieldType";
import { Label } from "@progress/kendo-react-labels";
import { Tooltip } from "@progress/kendo-react-tooltip";
import infoIcon from "../../assets/CaseFileIcons/info-icon.png";

const QuestionField = ({
  field = { label: "", required: false, gridWidth: 7, gridOffset: 0 },
  userScreenFieldId = "",
  isSubmitted = false,
  handleInputChange = () => {},
  validationMessage = () => {},
  fieldIndex = 0,
  formData = {},
  fromScreenDesigner = false,
}) => {
  const renderLabel = (field) => {
    const hasHelpText = field.helpText && field.helpText.trim() !== "";
    return field.label ? (
      <div className="d-flex">
        <Label
          className={`fw-semibold fs-sm mb-1 text-wrap `}
          style={{
            maxWidth: field.labelAboveField ? "100%" : "120px",
            minWidth: field.labelAboveField ? "" : "50px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: field.labelAboveField ? "normal" : "nowrap",
          }}
        >
          {field.label}
          {field.required && <span style={{ color: "red" }}> *</span>}
        </Label>
        {hasHelpText && (
          <Tooltip anchorElement="target" position="top">
            <img
              style={{
                marginLeft: "5px",
                cursor: "pointer",
              }}
              src={infoIcon}
              alt="Info"
              width="14px"
              height="14px"
              title={field.helpText}
            />
          </Tooltip>
        )}
      </div>
    ) : null;
  };

  return (
    <div
      id="field"
      key={fieldIndex}
      className={
        `ps-2  align-items-center justify-content-center gap-3 col-md-${
          field.gridWidth || 12 - (field.gridOffset || 0)
        }  offset-md-${field.gridOffset || 0} ` +
        (field.labelAboveField ? "" : " d-flex ") +
        (fromScreenDesigner ? " mb-0 " : " mb-3 ")
      }
    >
      <div
        className={
          "d-flex align-items-center" +
          (field.labelAboveField ? "" : " pe-3 text-end text-wrap") +
          (field.cssClass ? " " + field.cssClass + " " : "")
        }
      >
        {renderLabel(field)}
      </div>

      <div
        className={field.labelAboveField ? "" : "col-md-8 "}
        style={{
          minWidth: fromScreenDesigner && "80%",
        }}
      >
        <FieldType
          field={field}
          userScreenFieldId={userScreenFieldId}
          formData={formData}
          onInputChange={handleInputChange}
          fromScreenDesigner={fromScreenDesigner}
        />
        {validationMessage(field, userScreenFieldId)}
      </div>
    </div>
  );
};

export default QuestionField;
